import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Promotions } from '../../models'
import { PaymentMethodService } from '../../services'

const log = new Logger('PaymentMethodDetailResolver')
@Injectable({ providedIn: 'root' })
export class PaymentMethodDetailResolver
  implements Resolve<Observable<Promotions>> {
  constructor(
    private paymentmethod: PaymentMethodService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let id = route.params['id']
    
    return this.paymentmethod.getDetail(id).pipe(
      map(data => {
        log.debug('paymentmethod Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/payment-method']))
    )
  }
}
